import React, { useState } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import { patchApi, getApi } from 'views/services/api';
import { toast } from 'react-toastify';
import { useParams } from 'react-router';
import EditReservation from './EditReservation';
import { useEffect } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { constant } from 'views/constant';
import axios from 'axios';

const CheckOut = ({ open, handleClose }) => {
  const [reservationData, setReservationData] = useState([]);
  const [editReservationOpen, setEditReservationOpen] = useState(false);
  const params = useParams();
  const reservationId = params.id;
  const hotelData = JSON.parse(localStorage.getItem('hotelData'));
  const FinalCheckOutTime = moment().format('hh:mm A');

  const [hoteldata, sethoteldata] = useState({});

  const fetchReservationData = async () => {
    try {
      const response = await getApi(`api/reservation/view/${reservationId}`);
      setReservationData(response.data.reservationData[0]);
      console.log('Reservation data fetched:', response.data.reservationData[0]);
    } catch (error) {
      console.log('Error fetching reservation data:', error);
      toast.error('Error al obtener los detalles de la reserva');
    }
  };

  useEffect(() => {
    fetchReservationData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [editReservationOpen]);

  const sendCheckoutHotelWhatsappMessage = async () => {
    console.log('Sending checkout WhatsApp message...');

    const url = constant.WHATSAPP_MESSAGE_URL;
    const accessToken = constant.WHATSAPP_TOKEN;

    const payload = {
      messaging_product: 'whatsapp',
      recipient_type: 'individual',
      to: `+91${reservationData?.customerDetails?.phoneNumber}`,
      type: 'template',
      template: {
        name: 'checkout_hotel_crm',
        language: {
          code: 'en_US'
        },
        components: [
          {
            type: 'header',
            parameters: [
              {
                type: 'text',
                text: `${reservationData?.customerDetails?.firstName}`
              }
            ]
          },
          {
            type: 'body',
            parameters: [
              {
                type: 'text',
                text: hotelData?.name || ''
              },
              {
                type: 'text',
                text: hotelData?.checkOutTime || ''
              },
              {
                type: 'text',
                text: hotelData.googleReviewURL || ''
              },
              {
                type: 'text',
                text: hotelData.websiteURL || ''
              },
              {
                type: 'text',
                text: hotelData.contact || ''
              }
            ]
          }
        ]
      }
    };

    try {
      const response = await axios.post(url, payload, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${accessToken}`
        }
      });
      console.log('WhatsApp checkout message sent successfully:', response.data);
    } catch (error) {
      console.error('Error sending checkout message:', error);
    }
  };

  const updateRoomHousekeepingStatus = async (roomId) => {
    try {
      console.log('Updating room housekeeping status for roomId:', roomId);

      const payload = {
        housekeepingStatus: 'dirty'
      };

      // Usar el endpoint correcto definido en _routes.js
      const result = await patchApi(`api/room/housekeeping-status/${roomId}`, payload);

      if (result && result.status === 200) {
        console.log('Room marked as dirty successfully');
        return true;
      } else {
        console.error('Failed to update room status', result);
        return false;
      }
    } catch (error) {
      console.error('Error updating room housekeeping status:', error);
      return false;
    }
  };

  const handleCheckOut = async () => {
    try {
      // Get hotel data
      const response = await getApi(`api/hotel/view/${hotelData._id}`);
      sethoteldata(response.data);

      // Update checkout time
      reservationData.FinalCheckOutTime = FinalCheckOutTime;

      // Extract roomId and roomNo for later use
      const roomId = reservationData?.roomId;
      const roomNo = reservationData?.roomNo;

      // Process checkout
      let result = await patchApi(`api/reservation/delete/${reservationId}`, reservationData);

      if (result) {
        // Update room housekeeping status
        if (roomId) {
          const statusUpdated = await updateRoomHousekeepingStatus(roomId);
          if (statusUpdated) {
            console.log(`Room #${roomNo} marked as dirty after checkout`);
          } else {
            toast.warning(`La habitación #${roomNo} no pudo ser marcada automáticamente como sucia`);
          }
        } else {
          console.warn('No roomId found in reservation data');
        }

        // DESACTIVADO: enviaba desde el navegador con un token de Meta
        // hardcodeado (ya revocado). Además nunca pudo funcionar acá: arma
        // el destinatario como `+91${telefono}` (código de India) y usa una
        // plantilla en inglés del template original.
        // if (response.data.checkOutButtonStatus === true) {
        //   sendCheckoutHotelWhatsappMessage();
        // }

        toast.success('Check-Out realizado exitosamente');
        handleClose();
      } else {
        toast.error('No se puede realizar el Check-Out');
      }
    } catch (error) {
      console.error('Checkout error:', error);
      toast.error('No se puede realizar el Check-Out');
    }
  };

  const handleCloseEditReservation = () => {
    setEditReservationOpen(false);
  };

  return (
    <>
      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>Check-Out</DialogTitle>
        <DialogContent>
          <p>¿Estás seguro de que quieres hacer el Check-Out?</p>
          {reservationData?.roomNo && (
            <p>La habitación #{reservationData.roomNo} será marcada como sucia para el departamento de limpieza.</p>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Cancelar
          </Button>
          <Button onClick={handleCheckOut} color="error" variant="contained">
            Confirmar
          </Button>
        </DialogActions>
      </Dialog>

      {/* Edit Reservation Dialog */}
      <EditReservation open={editReservationOpen} handleClose={handleCloseEditReservation} data={reservationData} />
    </>
  );
};

CheckOut.propTypes = {
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired
};

export default CheckOut;
